"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Close = function Close(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4099 11.9991L18.7061 6.71288C19.098 6.32104 19.098 5.68573 18.7061 5.29388C18.3143 4.90204 17.679 4.90204 17.2871 5.29388L12.0009 10.5901L6.71459 5.29388C6.32274 4.90204 5.68743 4.90204 5.29559 5.29388C4.90374 5.68573 4.90374 6.32104 5.29559 6.71288L10.5918 11.9991L5.29559 17.2854C5.10641 17.473 5 17.7285 5 17.9949C5 18.2614 5.10641 18.5168 5.29559 18.7044C5.48322 18.8936 5.73864 19 6.00509 19C6.27154 19 6.52695 18.8936 6.71459 18.7044L12.0009 13.4082L17.2871 18.7044C17.4748 18.8936 17.7302 19 17.9966 19C18.2631 19 18.5185 18.8936 18.7061 18.7044C18.8953 18.5168 19.0017 18.2614 19.0017 17.9949C19.0017 17.7285 18.8953 17.473 18.7061 17.2854L13.4099 11.9991Z"
  }));
};

exports.Close = Close;